const TaskManagerType = {
    PiMeasurementReader: 'PiMeasurementReader',
    LabMeasurementReader: 'LabMeasurementReader',
    MeasurementMerge: 'MeasurementMerge',
    OutlierDetectorTrainer: 'OutlierDetectorTrainer',
    OutlierDetection: 'OutlierDetection',
    DataClean: 'DataClean',
    // DataSplit: 'DataSplit',
    ModelValidation: 'ModelValidation',
    Optimize: 'Optimize',
    OptimizersComparison: 'OptimizersComparison',
    UnitOptimizer: 'UnitOptimizer',
    OptimizationPipeline: 'OptimizationPipeline',
    EdtDynamicCheck: 'EdtDynamicCheck',
    PiWriter: 'PiWriter',
    OpcDaWriter: 'OpcDaWriter',
};

export default TaskManagerType;